import {
  ADD_MICROLOAN_SETTINGS_ERROR,
  ADD_MICROLOAN_SETTINGS_START,
  ADD_MICROLOAN_SETTINGS_SUCCESS,
} from 'constants/action-types/settings/addMicroloanSettings';

export default (state, { type, payload }) => {
  switch (type) {
    case ADD_MICROLOAN_SETTINGS_START:
      return {
        ...state,
        addMicroloanSettings: {
          loading: true,
          error: null,
          data: null,
        },
      };
    case ADD_MICROLOAN_SETTINGS_ERROR:
      return {
        ...state,
        addMicroloanSettings: {
          ...state.addMicroloanSettings,
          error: payload,
          loading: false,
        },
      };
    case ADD_MICROLOAN_SETTINGS_SUCCESS:
      return {
        ...state,
        addMicroloanSettings: {
          ...state.addMicroloanSettings,
          data: payload.data,
          loading: false,
        },
      };
    default:
      return null;
  }
};
